// Veri Yönetimi derin bağlantısı (K-B10 + TODO-KPI-141): `?packageId=` ("Bu paketten set kur") ve
// `?clientId=&fork=1` (ProjectNew "Sektör paketinden set kur") Set kur penceresini açar. Sorgu İLK
// render'da yakalanır: `KpiContextBar` `?clientId` hydrate ettikten sonra URL'i temizler, parametre
// o zamana kadar okunmazsa kaybolurdu. `consume()` bekleyen isteği ve URL'deki parametreleri siler.

import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export interface ForkDeeplink {
  packageId: string | null;
  clientId: string | null;
  /** istek var (paket ya da `fork=1`) ve henüz tüketilmedi */
  pending: boolean;
  consume: () => void;
}

const nonEmpty = (v: string | null): string | null => (v === null || v === "" ? null : v);

export function parseForkDeeplink(search: string): {
  packageId: string | null;
  clientId: string | null;
  fork: boolean;
} {
  const q = new URLSearchParams(search);
  return {
    packageId: nonEmpty(q.get("packageId")),
    clientId: nonEmpty(q.get("clientId")),
    fork: q.get("fork") === "1",
  };
}

export function useForkPackageDeeplink(): ForkDeeplink {
  const location = useLocation();
  const navigate = useNavigate();
  const [req, setReq] = useState(() => parseForkDeeplink(location.search));
  const pending = req.packageId !== null || req.fork;
  const consume = useCallback(() => {
    setReq({ packageId: null, clientId: null, fork: false });
    const q = new URLSearchParams(window.location.search);
    if (q.has("packageId") || q.has("fork")) {
      q.delete("packageId");
      q.delete("fork");
      const rest = q.toString();
      void navigate(window.location.pathname + (rest ? `?${rest}` : ""), { replace: true });
    }
  }, [navigate]);
  return { packageId: req.packageId, clientId: req.clientId, pending, consume };
}
